import {Maybe, MaybeString} from "../../types/Maybe";
import {RRCalendarDayType} from "../../types/RRCalendarDayType";
import {RREmployeeType} from "../../types/RREmployeeType";
import {RRCalendarDateDataType} from "../../types/RRCalendarDataType";
import CenteredColumn from "../../components/CenteredColumn";
import {timeToString} from "../../tools";
import {Badge, Button, Col, ListGroup, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCircleRight, faFaceFrown, faFaceMeh, faFaceSmile, faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import FaceControl from "./FaceControl";
import {RREventType} from "../../types/RREventType";

export default function CalendarCellContent(props: {
    montageSign: string;
    offDay: Maybe<RRCalendarDayType>;
    employee: RREmployeeType;
    event: RREventType;
    item: RRCalendarDayType | undefined;
    values: RRCalendarDateDataType; colIndex: number,
    onClickStart?: (item: Maybe<RRCalendarDayType>) => void
    onClickEnd?: (item: Maybe<RRCalendarDayType>) => void
}) {
    const item = props.item;
    const MONTAGE_SIGN = props.montageSign || "M";
    const eventId = props.event.id;

    return <CenteredColumn className={
        eventId === "WAREHOUSE" ? "bg-warehouse" :
            (
                (props.colIndex % 2 === 0 ? "bg-secondary-light" : "bg-light") +
                (props.colIndex === 0 ? " td-left-dbl-border" : "")
            )}>
        {
            item?.dayType && item.dayType === "WORKDAY" ?
                <Row className={"flex-nowrap"}>
                    <Col className={"text-nowrap"} xs={"auto"}>
                        <Button variant={"outline-secondary"} size={"sm"}
                                disabled={!props.onClickStart}
                                onClick={() => props.onClickStart && props.onClickStart(item)}>
                            {timeToString(item?.eventDayStart)}
                        </Button>&nbsp;
                        <FontAwesomeIcon icon={faCircleRight}/>&nbsp;
                        <Button variant={"outline-secondary"} size={"sm"}
                                disabled={!props.onClickEnd}
                                onClick={() => props.onClickEnd && props.onClickEnd(item)}>
                            {
                                timeToString(item?.eventDayEnd) || "..."
                            }
                        </Button>
                    </Col>
                    <Col className={"text-center pt-1"}>
                        {item?.isSupervisor && <><Badge pill bg="primary">S</Badge>{' '}</>}
                    </Col>
                    {
                        item?.eventDayEnd && item?.face && <Col><FaceControl face={item.face}/></Col>
                    }
                    {
                        item?.isConfirmed && <Col className={"text-success text-nowrap"} title={item?.notes} >
                            <FontAwesomeIcon icon={faCheck} size={"2x"}/>
                            { item?.notes && <span className={"text-dark"}><FontAwesomeIcon icon={faCircleInfo} /></span> }
                        </Col>
                    }
                </Row>
                :
                <div
                    className={"link-secondary lh-2em cursor-pointer text-dark " + (item?.dayType ? " bg-danger-light" : "")}
                    onClick={() => props.onClickStart && props.onClickStart(item)}> {item?.dayType}&nbsp;</div>
        }
    </CenteredColumn>;
}
